import React, { Component } from 'react';
import "./Popup.scss";

export default class Popup extends Component {
  constructor() {
    super();
    this.state = {}
  }

  render() {
    if (this.props.itemPopup == null) return (<div></div>)
    const {
      Accessibility,
      Alldetails,
      Bus,
      Fax,
      Filter,
      WAZE,
      Site,
      Sitename,
      Phonesite,
      Phoneforinquiries,
      Pessoverdetails,
      Moredetails,
      Loccation,
      Houres,
      Handicappedservices,
      index,
      game,
      error
    } = this.props.itemPopup;
    return (
      <div>
        {/* <div className="fade" onClick={() => {
          this.props.togglePopup(null);
        }}></div> */}
        <section className={`section section-popup pop-pin-${index}`}>
          <div className="popup-container-out">
            <div className="close" onClick={() => {
              this.props.togglePopup(null);
            }}></div>
            <div className="popup-container">
              <div className="wrapper-text">
                {/* <div className="text">
                  <span>אתר מס: </span>{index + 1}'
            </div> */}
                {game != null ?
                  <div className="button"><a href={game} title="" target="_blank">
                    למה לבוא? לחצו</a>
                  </div> : ""}
                {error != null ?
                <div className="text error">
                  <span>הערה: </span>{error}
                </div> : ""}
                <div className="text">
                  <span>שם האתר: </span>{Sitename}
                </div>
                <div className="text">
                  <span>על האתר: </span>
                  {Alldetails}
                </div>
                {Pessoverdetails ?
                  <div className="text">
                    <span>מיוחד לפסח: </span>{Pessoverdetails}
                  </div> : ""}
                <div className="text">
                  <span>מידע נוסף: </span>{Moredetails}
                </div>
                <div className="text">
                  <span>שעות פעילות בחוה"מ: </span>{Houres}
                </div>
                <div className="text">
                  <span>נגישות: </span>{Accessibility}
                </div>
                <div className="text">
                  <span>תאור נגישות: </span>{Handicappedservices}
                </div>
                <div className="text">
                  <span>הגעה בווייז: </span>{WAZE}
                </div>
                <div className="text">
                  <span>איך מגיעים? </span>{Loccation}
                </div>
                <div className="text">
                  <span>הגעה בתחבורה ציבורית: </span>{Bus}
                </div>
                <div className="text">
                  <span>טלפון האתר: </span>{Phonesite}
                </div>
                <div className="text">
                  <span>טלפון לבירורים: </span>{Phoneforinquiries}
                </div>
                <div className="text">
                  <span>פקס האתר: </span>{Fax}
                </div>
                <div className="text">
                  <a href={Site} title="" target="_blank">כניסה לאתר האינטרנט</a>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/Components/Popup/Popup.jsx